"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const NotificationsTab_1 = require("../../pages/NotificationsTab");
const SelectAllNotifications = (0, react_1.memo)(({ onClick, className, nextAction }) => {
    const handleSelect = () => {
        onClick(nextAction);
    };
    const title = nextAction === NotificationsTab_1.SelectAction.Select
        ? (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.selectAll)
        : (0, i18n_1.Localized)(i18n_1.Strings.settings.notifications.deselectAll);
    return ((0, jsx_runtime_1.jsx)(Container, { className: className, "data-e2e": 'Container', children: (0, jsx_runtime_1.jsx)(LabelContainer, { onClick: handleSelect, "data-e2e": 'LabelContainer', children: (0, jsx_runtime_1.jsx)(Label, { "data-e2e": 'Label', children: title }) }) }));
});
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: left;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    width: 75%;
  `)};
`;
const LabelContainer = styled_components_1.default.div `
  display: flex;
  cursor: pointer;
  margin-left: 24px;
  white-space: nowrap;

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    margin-left: 29px;
  `)};
`;
const Label = styled_components_1.default.span `
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.designSystem.textSecondary};
`;
exports.default = SelectAllNotifications;
